module.exports = __webpack_public_path__ + "img/ashish-boyne-watergodasb.91cc7699.jpg";